import React, { useContext, useState } from "react"
import { Modal } from "react-bootstrap";
import {
  Autocomplete,
  Button,
  InputLabel,
  TextField,
  MenuItem,
  Select,
  Switch,
  FormControlLabel
} from "@mui/material";
import language from "../../../nls/language.json";
import Context from "../../../context/Context";
import '../Combinations.css';

export default function AddProductModal({
  showModalAdd,
  setShowModalAdd,
  handleAddProducts,
  selectedAddProduct,
  grupoProdutos,
  produtosOptions,
  postProduct,
  checkSaveBtn
}) {
  const {
    selectedCountry,
  } = useContext(Context);

  const [newGroup, setNewGroup] = useState(false);

  return (
    <Modal size="lg" show={showModalAdd} onHide={() => setShowModalAdd(false)}>
      <Modal.Header closeButton>
        <Modal.Title>
          {language[selectedCountry.name].Cadastro.combinacoes.produtos.modal.adicionarProduto.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4 py-3">
        <div className="d-flex flex-column gap-3">
          <div className="d-flex justify-content-start">
            <FormControlLabel
              className="d-flex align-items-center"
              label="NOVO GRUPO"
              control={
                <Switch
                  checked={newGroup}
                  onChange={() => setNewGroup(!newGroup)}
                />
              }
            />
          </div>

          <div className="d-flex flex-row gap-3">
            <div className="d-flex flex-column w-50">
              <InputLabel sx={{ fontSize: '0.95rem', fontWeight: 600, mb: 1 }}>
                {language[selectedCountry.name].Cadastro.combinacoes.produtos.modal.adicionarProduto.labels.produto}
              </InputLabel>
              <Autocomplete
                options={produtosOptions}
                getOptionLabel={(opt) => `${opt.descricao} (${opt.valor})`}
                filterOptions={(opts, { inputValue }) =>
                  opts.filter(o =>
                    o.descricao.toLowerCase().includes(inputValue.toLowerCase()) ||
                    o.valor.toLowerCase().includes(inputValue.toLowerCase())
                  )
                }
                onChange={(_, opt) => handleAddProducts({ name: "prodGrupo_ProdCod", value: opt?.valor ?? "" }, "PRODUTO")}
                renderInput={(params) => (
                  <TextField {...params} required fullWidth placeholder="Selecione o Produto" />
                )}
              />
            </div>

            <div className="d-flex flex-column w-50">
              <InputLabel sx={{ fontSize: '0.95rem', fontWeight: 600, mb: 1 }}>
                {language[selectedCountry.name].Cadastro.combinacoes.produtos.modal.adicionarProduto.labels.grupo}
              </InputLabel>
              {newGroup ? (
                <TextField
                  name="prodGrupo_GrupoNome"
                  required
                  fullWidth
                  placeholder="Nome do Grupo"
                  onChange={({ target }) => handleAddProducts(target, "PRODUTO")}
                />
              ) : (
                <Select
                  value={selectedAddProduct.prodGrupo_GrupoNome}
                  onChange={({ target }) => {
                    handleAddProducts({ name: "prodGrupo_GrupoNome", value: target.value }, "PRODUTO")
                  }}
                >
                  {grupoProdutos.map((itemProd, i) => (
                    <MenuItem
                      key={`grupProd-${itemProd.prodGrupo_GrupoNome}-${i}`}
                      value={itemProd.prodGrupo_GrupoNome}
                    >
                      {itemProd.prodGrupo_GrupoNome}
                    </MenuItem>
                  ))}
                </Select>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="text"
          sx={{ marginRight: 2 }}
          onClick={() => setShowModalAdd(false)}
        >
          {language[selectedCountry.name].Cadastro.combinacoes.produtos.modal.adicionarProduto.btnCancelar}
        </Button>
        <Button
          variant="contained"
          onClick={() => postProduct(selectedAddProduct)}
          disabled={checkSaveBtn(selectedAddProduct)}
        >
          {language[selectedCountry.name].Cadastro.combinacoes.produtos.modal.adicionarProduto.btnSalvar}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
